export default {
  name: 'SectionSheet',
};